import React from "react";
import { renderRichText, storyblokEditable } from "gatsby-source-storyblok";

const CorpImgTextRow = ({blok}) => {

  return (
    <section className="flex flex-wrap" {...storyblokEditable(blok)}>
      { blok.img?.filename &&
      <div className={`${ blok.imgPosition === 'left' ? 'md:order-1 md:justify-end' : 'md:order-2 md:justify-start' } w-full md:w-1/2 flex justify-center items-center`}>
        <img className="w-full h-auto md:w-[600px] md:h-[350px] object-cover" loading="lazy" src={`${blok.img.filename}/m/`} alt={blok.img.alt} />
      </div>
      }
      <div className={`${ blok.imgPosition === 'left' ? 'md:order-2 md:justify-start' : 'md:order-1 md:justify-end' } w-full md:w-1/2 flex justify-start items-center`}>
        <div className="w-[600px] p-8">        
          <h2 className="text-lg font-bold mb-8">{blok.title}</h2>
          <div className="text-md" dangerouslySetInnerHTML={{__html: renderRichText(blok.detail)}} />
        </div>
      </div>
    </section>
  );
};
  
export default CorpImgTextRow
